"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zIndex = 2008; // to be more than for regular modal

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_abort", function () {
      _this.props.promise.onReject();
    });

    _defineProperty(_assertThisInitialized(_this), "_confirm", function () {
      _this.props.promise.onResolve();
    });

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-backdrop fade in",
        style: {
          zIndex: zIndex
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal fade in",
        style: {
          display: 'block',
          zIndex: zIndex + 1
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-dialog"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close",
        onClick: this._abort
      }, "\xD7"), /*#__PURE__*/_react.default.createElement("h4", {
        className: "modal-title"
      }, this.props.message)), this.props.description && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, this.props.description), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this._abort
      }, this.props.abortLabel), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this._confirm
      }, this.props.confirmLabel))))));
    }
  }]);

  return _default;
}(_react.default.Component);

exports.default = _default;

_defineProperty(_default, "propTypes", {
  message: _propTypes.default.node,
  description: _propTypes.default.node,
  confirmLabel: _propTypes.default.string,
  abortLabel: _propTypes.default.string,
  promise: _propTypes.default.object
});

_defineProperty(_default, "defaultProps", {
  message: 'Are you sure?',
  description: '',
  confirmLabel: 'Yes',
  abortLabel: 'No'
});